import axios from 'axios';

export function createFilterAnnotationsPreference(data) {
    return axios({
        method: 'POST',
        url: `/api/v1/admin/preferences/filter/${data.name}`,
        withCredentials: true,
        data,
    })
        .then(response => response)
        .catch(response => response.error);
}


// WEBPACK FOOTER //
// ./app/services/preferences/filterAnnotations.js